import { deepmerge } from '@mui/utils';
import type { PartialSemanticPaletteColors, SemanticPaletteColors } from '../types';

/** Deep-merge partial overrides onto a base semantic palette (from an app theme preset). */
export function mergeSemanticPaletteColors(
  base: SemanticPaletteColors,
  ...partials: Array<PartialSemanticPaletteColors | undefined>
): SemanticPaletteColors {
  let acc: SemanticPaletteColors = base;
  for (const partial of partials) {
    if (partial !== undefined) {
      acc = deepmerge(acc, partial);
    }
  }
  return acc;
}
